// src/config/firebase.jsx
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCD29Xs1C46pGMbsQd2NEi6F8Jh7DPkPAk",
  authDomain: "cal-coffee-chat.firebaseapp.com",
  projectId: "cal-coffee-chat",
  storageBucket: "cal-coffee-chat.appspot.com",
  messagingSenderId: "886447383370",
  appId: "1:886447383370:web:d53b127a3c8ca7fe0cd7b3",
  measurementId: "G-37XKR24Q71"
};

// Initialize Firebase (Singleton Pattern)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleAuthProvider = new GoogleAuthProvider();
export const storage = getStorage(app);